import { render, staticRenderFns } from "./LeadsClosedMiniCard.vue?vue&type=template&id=309ea276&"
import script from "./LeadsClosedMiniCard.vue?vue&type=script&lang=js&"
export * from "./LeadsClosedMiniCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports